import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ContextService, XenaClient } from 'src/app/services';
import { BaseService } from 'src/app/xena-api/controllers/base';
import { IDataImport } from 'src/app/xena-api/dtos';
import { IListOptionsFilter } from 'src/app/xena-api/filters';
import { ISaveResult } from 'src/app/xena-api/response-types';

@Injectable({
  providedIn: 'root'
})
export class DataImportService extends BaseService<IDataImport, IListOptionsFilter> {
  constructor(xenaClient: XenaClient, context: ContextService) {
    super(xenaClient, context, 'DataImport');
  }

  triggerImport(dataImportId: number): Observable<ISaveResult> {
    const buildUrl = this.buildUrl(dataImportId)
    const resourcePath: string = `${buildUrl}/TriggerImport`;
    return this.xenaClient.put<void, ISaveResult>(resourcePath, null);
  }
}
